export default function prettyHour(h:number) {
  if (h === 0) {
    return '12am'
  } if (h === 12) {
    return '12pm'
  } if (h < 12) {
    return `${h}am`
  } if (h === 24) {
    return '12am (+1)'
  } if (h < 24) {
    return `${h - 12}pm`
  } return `${h - 24}am (+1)`
}
